/**
 * Frontend Sentry init (React/Vite).
 *
 * Sampling policy (FOUND-02):
 *   - 100% errors
 *   - 10% traces
 *   - 0% replays (disabled pre-launch; revisit once PII masking story is solid)
 *
 * PII scrubbing shares the exact same module used by edge functions
 * (`supabase/functions/_shared/pii-scrub.ts`) — Vite resolves the relative
 * path into its own bundle. This guarantees FE and edge emit identical
 * redaction semantics.
 */

import * as Sentry from '@sentry/react';
import { scrubPII } from '../../supabase/functions/_shared/pii-scrub';

export function initFrontendSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) {
    // eslint-disable-next-line no-console
    console.log('[sentry] VITE_SENTRY_DSN not set; skipping FE init');
    return;
  }
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? 'production',
    release: (import.meta.env.VITE_GIT_SHA as string | undefined) ?? 'unknown',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    beforeSend(event: unknown) {
      return scrubPII(event as Record<string, unknown>) as any;
    },
  });
}
